// Shared input formatters + validators used across the site's forms.

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (v) => EMAIL_RE.test(String(v || "").trim());

// Formats a US phone number as the user types: (XXX) XXX-XXXX
// Only digits are kept; parentheses, space and hyphen are auto-inserted.
export function formatPhone(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 10);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

// Formats an EIN as the user types: XX-XXXXXXX
// Only digits are kept (max 9); the hyphen is auto-inserted after the 2nd digit.
export function formatEIN(value) {
  const d = String(value || "").replace(/\D/g, "").slice(0, 9);
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}-${d.slice(2)}`;
}
